<template>
  <div>
    <header>
      <div class="header-bar">
        <div class="header-wrapper">
          <div  class="header-logo"><router-link to="/"><img src="/img/logo.png" /></router-link></div>
          <ul class="header-menu">
            <li><router-link to="/">Събития</router-link></li>
            <li><router-link to="/contacts">Контакти</router-link></li>
          </ul>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: "Header"
}
</script>

<style scoped lang="scss">
.header-bar {
  width: 100%;
  //max-width: 1280px;
  margin: 0 auto;
  background: #208ffd;
  display: flex;
  justify-content: space-between;

  .header-wrapper {
    width: 100%;
    max-width: 1180px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    @media all and (min-width: 600px){
      flex-direction: row;
    }
  }

  .header-logo {
    flex: 1;
    display: flex;
    justify-content: center;

    @media all and (min-width: 600px){
      justify-content: flex-start;
    }

    img {
      height: 100%;
      max-height: 45px;
      align-self: center;
    }
  }

  .header-menu {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 45px;
    align-self: center;
    padding: 0;
    margin: 0;

    a {
      color: white;
      line-height: 24px;
      margin: 0 10px;
      font-size: 18px;
      text-transform: uppercase;
    }
  }
}
</style>
